import React, { useRef, useEffect } from "react";
import "./index.scss";
import { useState } from "react";
// import { useIsMobile } from "../../../utils/helper";

const StepperTabs = ({
  steps,
  currentStep,
  setCurrentStep,
  direction = "horizontal",
  enableClick = false,
}) => {
  const containerRef = useRef();
  const [responsiveDirection, setResponsiveDirection] = useState(direction);

  // Use the custom hook to detect mobile view
  // const isMobile = useIsMobile();

  // Update responsive direction based on mobile status
  // useEffect(() => {
  //   setResponsiveDirection(isMobile ? "horizontal" : direction);
  // }, [direction, isMobile]); // Add isMobile as a dependency

  useEffect(() => {
    scrollToCurrentStep();
  }, [currentStep]);

  const scrollToCurrentStep = () => {
    const container = containerRef.current;
    const activeStepElement =
      container?.querySelectorAll(".step-container")[currentStep];

    if (container && activeStepElement) {
      const containerRect = container.getBoundingClientRect();
      const activeStepRect = activeStepElement.getBoundingClientRect();

      if (direction === "horizontal") {
        // Scroll horizontally to bring the active step into view
        const offset = activeStepRect.left - containerRect.left;
        container.scrollBy({ left: offset, behavior: "smooth" });
      } else if (direction === "vertical") {
        const offset = activeStepRect.left - containerRect.left;
        container.scrollBy({ left: offset, behavior: "smooth" });
      } else {
        // Scroll vertically for vertical direction
        const offset = activeStepRect.top - containerRect.top;
        container.scrollBy({ top: offset, behavior: "smooth" });
      }
    }
  };

  return (
    <div
      ref={containerRef}
      className={`step-indicator-container ${responsiveDirection}`}
    >
      {steps.map((step, index) => (
        <div
          key={index}
          className="step-container"
          onClick={enableClick ? () => setCurrentStep(index) : undefined}
          style={{ cursor: enableClick ? "pointer" : "default" }}
        >
          <div className="step-details">
            <span
              className={`step-indicator ${
                index <= currentStep ? "active-step-indicator" : ""
              }`}
            >
              {index + 1}
            </span>
            {index < steps.length - 1 && (
              <div
                className={`step-line ${
                  index < currentStep ? "active-step-line" : ""
                }`}
              ></div>
            )}
          </div>
          <div className="step-label">
            {step.name.replace(/(&nbsp;|\s)+/g, " ")}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepperTabs;
